import type { Variants } from 'framer-motion';

export const cardVariants: Variants = {
  offscreen: {
    scale: 0.9,
    opacity: 0,
  },
  onscreen: {
    scale: 1,
    opacity: 1,
    transition: {
      type: 'spring',
      bounce: 0.2,
      duration: 1,
    },
  },
};

export const cardVariantsNoScale: Variants = {
  offscreen: {
    opacity: 0,
  },
  onscreen: {
    opacity: 1,
    transition: {
      type: 'spring',
      bounce: 0.2,
      duration: 1,
    },
  },
};
export const cardVariantsNoOpacityFullScale: Variants = {
  offscreen: {
    scale: 0,
  },
  onscreen: {
    scale: 1,
    transition: {
      type: 'spring',
      bounce: 0.2,
      duration: 1,
    },
  },
};
